import request from '@/utils/request'

// 查询招采文件申请列表
export function listBidFileApply(query) {
  return request({
    url: '/api/bidFileApply/list',
    method: 'get',
    params: query
  })
}

// 查询招采文件申请详细
export function getBidFileApply(id) {
  return request({
    url: '/api/bidFileApply/getInfoForPublicView/' + id,
    method: 'get'
  })
}